<template>
  <basic-container>
    <div class="main-container">
        <first-block></first-block>
        <second-block></second-block>
        <third-block v-if="lang === 'zh'"></third-block>
        <fourth-block v-if="lang === 'zh'"></fourth-block>
        <fifth-block></fifth-block>
        <sixth-block></sixth-block>
		
    </div>
  </basic-container>
</template>

<script>
import FirstBlock from "./components/firstBlock.vue";
import SecondBlock from "./components/secondBlock.vue";
import ThirdBlock from "./components/thirdBlock.vue";
import FourthBlock from "./components/fourthBlock.vue";
import FifthBlock from "./components/fifthBlock.vue";
import SixthBlock from "./components/sixthBlock.vue";
export default {
  components: { FirstBlock,SecondBlock,ThirdBlock,FourthBlock,FifthBlock,SixthBlock},
  name: "index",
  data() {
    return {
      lang: localStorage.getItem("lang")
    };
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
